import useFormatDate from '@/src/hooks/date/useFormatDate'
import { useFormatTime } from '@/src/hooks/srp/formatTime'
import { useGetSearchParamsObj } from '@/src/hooks/srp/searchParams'
import { FlightCard, FlightRouteInfo, JsonsData } from '@/src/types/flight'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'
import { Box, Typography } from '@mui/material'
import { Dot } from 'lucide-react'
import { useTranslations } from 'next-intl'
import React from 'react'

export interface TripInfoProps {
    flight: FlightCard
    jsons: JsonsData
    sector: FlightRouteInfo
    flightIndex: number
}

const TripInfo: React.FC<TripInfoProps> = ({ flight, jsons, sector, flightIndex }) => {
    const formatTime = useFormatTime()
    const { formatDate } = useFormatDate()
    const t = useTranslations('common')
    const { urlQueryObj } = useGetSearchParamsObj()
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            alignItems={'flex-start'}
            sx={{ bgcolor: 'rgba(42, 82, 152, 0.08)', borderRadius: '8px' }}
            mx={2}
            px={2}
            py={2}
            my={1}
        >
            <Box display={'flex'}>
                {flightIndex != 0 && (
                    <>
                        <Typography variant="h2" fontWeight={'bold'} fontSize={'18px'} gutterBottom>
                            {flightIndex === -1 ? 'Multicity' : flightIndex === 1 ? t('onward') : t('return')}
                        </Typography>
                        <Dot size={24} />
                    </>
                )}
                <Typography variant="h2" fontWeight={'bold'} fontSize={'18px'} gutterBottom>
                    {jsons.ap?.[sector?.firstDeparture?.airportCode]?.c}
                </Typography>
                <Typography variant="h2" fontWeight={'bold'} fontSize={'18px'} mx={'0.5rem'} gutterBottom>
                    →
                </Typography>
                <Typography variant="h2" fontWeight={'bold'} fontSize={'18px'} gutterBottom>
                    {jsons.ap?.[sector?.lastArrival?.airportCode]?.c}
                </Typography>
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={1}>
                <Box display={'flex'} alignItems={'center'} gap={0.5}>
                    <Typography variant="body2">{formatTime(flight.totalDuration)}</Typography>
                    <Typography variant="body2"></Typography>
                    <Dot size={20} color="#4B5563" />
                    <Typography variant="body2">
                        {sector.stops === 0
                            ? t('direct')
                            : sector.stops === 1
                              ? t('1 stop')
                              : `${sector.stops} ${t('stops', { s: 's' })}`}
                    </Typography>
                    <Dot size={20} color="#4B5563" />
                    <Typography variant="body2">
                        {formatDate(convertDDMMYYYYToISO(sector.firstDeparture.date), 'ddd, DD MMM')}
                    </Typography>
                    <Dot size={20} color="#4B5563" />
                    <Typography variant="body2">{t(urlQueryObj?.class as string)}</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default TripInfo
